import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {Link} from 'react-router-dom';
import {adminGetConversations} from "../../../services/api/admin";
import ConversationDetailsModal from "./ConversationDetailsModal";
import {AdminTable} from "../../../components/Admin/Common/AdminTable";
import {Button} from "flowbite-react";
import {useNavigate} from 'react-router-dom';
import {moment} from "../../../services/moment-extensions";

const AdminConversations = () => {
    const navigate = useNavigate();

    const {status, page, per_page} = useParams();
    const [selectedRow, setSelectedRow] = useState(null);
    const [conversationsFetched, setConversationsFetched] = useState(false);
    const [conversationPagination, setConversationPagination] = useState({
        total: 0,
        count: 0,
        per_page: parseInt(per_page, 10) || 10,
        current_page: parseInt(page, 10) || 1,
        total_pages: 1
    });
    const [conversationData, setConversationData] = useState([]);
    const [activeFilterOptions, setActiveFilterOptions] = useState({
        status: status || 'all',
        page: conversationPagination.current_page,
        per_page: conversationPagination.per_page
    });


    const fetchConversations = async () => {
        if (!conversationData.length && !conversationsFetched)
            try {

                const {data, meta} = await adminGetConversations(activeFilterOptions);
                const transformedData = data.map((item) => ({
                    id: {data: <Link to={"/admin/conversation/" + item.id}>{item.id}</Link>, classes: "sl-min-w-10"},
                    broker: {
                        data: item.broker.name + (item.latest_message.account.type === 'broker' ? '*' : ''),
                        classes: ""
                    },
                    vendor: {
                        data: item.vendor.name + (item.latest_message.account.type === 'vendor' ? '*' : ''),
                        classes: ""
                    },
                    last_message_date: {data: moment(item.latest_message.created_at * 1000).toDateLongWithToday(), classes: ""},
                    last_message: {
                        data: item.latest_message.content,
                        classes: "sl-text-left sl-ellipsis-three-line sl-cursor-pointer",
                        contentClasses: 'sl-ellipsis-three-line sl-max-w-388',
                        onClick: () => setSelectedRow({
                            id: item.id,
                            message: item.latest_message.content
                        })
                    },
                }));

                setConversationsFetched(true);
                setConversationData(transformedData);
                setConversationPagination(meta.pagination);
                setActiveFilterOptions({
                    status: activeFilterOptions.status,
                    page: meta.pagination.current_page,
                    per_page: meta.pagination.per_page
                })

            } catch (e) {
                console.error('Error fetching conversations:', e);
            }
    }

    React.useEffect(() => {
            fetchConversations(activeFilterOptions).then(r => console.log('Conversations fetched'));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [activeFilterOptions]);


    React.useEffect(() => {
            setActiveFilterOptions({
                status: status || 'all',
                page: conversationPagination.current_page,
                per_page: conversationPagination.per_page
            })
            setConversationData([]);
            setConversationsFetched(false);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [status]);

    React.useEffect(() => {
            setActiveFilterOptions({
                status: status || 'all',
                page: page,
                per_page: per_page
            })
            setConversationData([]);
            setConversationsFetched(false);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, per_page]);


    const headers = [
        {data: 'ID', classes: ""},
        {data: 'Broker', classes: ""},
        {data: 'Vendor', classes: ""},
        {data: 'Last message date', classes: ""},
        {data: 'Last message', classes: "sl-text-left"}
    ]; // Table headers


    return (
        <div>
            {selectedRow && <ConversationDetailsModal onClose={() => setSelectedRow(null)} data={selectedRow}/>}
            <main className="sl-main sl-mt-8">
                <div className="sl-container sl-m-auto sl-my-8">
                    <h1>Admin Conversations</h1>


                    <div className={"flex flex-col sl-align-flex-start sl-pt-8"}>
                        <Button.Group>
                            <Button
                                onClick={() => navigate('/admin/conversations')}
                                color={activeFilterOptions.status === 'all' ? "blue" : "gray"}>All</Button>
                            <Button
                                onClick={() => navigate('/admin/conversations/unread')}
                                color={activeFilterOptions.status === 'unread' ? "blue" : "gray"}>Unread</Button>
                            <Button
                                onClick={() => navigate('/admin/conversations/archived')}
                                color={activeFilterOptions.status === 'archived' ? "blue" : "gray"}>Archived</Button>
                        </Button.Group>
                    </div>

                    <AdminTable
                        dataFetched={conversationsFetched}
                        headers={headers}
                        data={conversationData}
                        paginationData={conversationPagination}
                        basePath={`/admin/conversations/` + activeFilterOptions.status}
                        paginator={conversationPagination}
                    />

                </div>
            </main>
        </div>
    );
};

export default AdminConversations;
